// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__ppltH","tab":"Tabs_tab__7HtYm","tabIcon":"Tabs_tabIcon__Il+rT","selectedTab":"Tabs_selectedTab__wOxlW","disabledTab":"Tabs_disabledTab__8M7Ti"};